/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.header[_ngcontent-%COMP%]{text-align:center;margin:0 0 5px!important}\n/*# sourceMappingURL=current-exchange-rates.component.css.map*/"];
export { styles as styles };
